import { render } from "./OrderHistoryEntry.vue?vue&type=template&id=f71c1318&scoped=true"
import script from "./OrderHistoryEntry.vue?vue&type=script&lang=js"
export * from "./OrderHistoryEntry.vue?vue&type=script&lang=js"

import "./OrderHistoryEntry.vue?vue&type=style&index=0&id=f71c1318&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f71c1318"]])

export default __exports__